var moduleMap = {
	"App": () => {
		return Promise.all([__webpack_require__.e(632), __webpack_require__.e(914), __webpack_require__.e(651), __webpack_require__.e(647), __webpack_require__.e(67), __webpack_require__.e(181), __webpack_require__.e(186), __webpack_require__.e(325), __webpack_require__.e(5)]).then(() => (() => ((__webpack_require__(7391)))));
	},
	"CreditLimitChangeRoute": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(651), __webpack_require__.e(647), __webpack_require__.e(67), __webpack_require__.e(181), __webpack_require__.e(186), __webpack_require__.e(715)]).then(() => (() => ((__webpack_require__(6540)))));
	},
	"AccountDetails": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(651), __webpack_require__.e(647), __webpack_require__.e(67), __webpack_require__.e(186), __webpack_require__.e(69)]).then(() => (() => ((__webpack_require__(3758)))));
	},
	"CreditLimitNotice": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(647), __webpack_require__.e(181), __webpack_require__.e(343)]).then(() => (() => ((__webpack_require__(1343)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});